import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";

const Panel = ({ onClick }) => {
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}></div>
      <div className={styles.btns}>
        <button
          className={cn("button", styles.button)}
          type="button"
          onClick={onClick}
        >
          Print
        </button>
      </div>
    </div>
  );
};
export default Panel;
